<template>
  <!-- 店铺新增，修改 -->
  <div>
    <el-dialog title="店铺" :visible.sync="dialogVisible" width="60%">
      <el-form :model="form" :rules="rules" label-width="110px" ref="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属合作商" required prop="coop_id">
              <cooperatorSelect
                :clearable="true"
                :condition="{ type: 'shop' }"
                :coopid.sync="form.coop_id"
                :info="form.map ? form.map.coop_name : ''"
                @change="changeCoop"
              ></cooperatorSelect>
            </el-form-item>
            <el-form-item label="店铺名称" required prop="shop_name">
              <el-input
                v-model="form.shop_name"
                placeholder="店铺名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="店铺logo" required>
              <avatar-uploader
                @getImgUrl="(v) => (form.shop_logo = v)"
                :url="temp.shop_logo"
              ></avatar-uploader>
            </el-form-item>
            <el-form-item label="行业" prop="industry">
              <el-input
                v-model="form.industry"
                placeholder="主营行业"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contact_phone">
              <el-input
                v-model="form.contact_phone"
                placeholder="联系电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="营业时间" prop="business_hours">
              <el-input
                v-model="form.business_hours"
                placeholder="如：09:00-21:00"
              ></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="form.sort"
                :min="0"
                label="排序"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="状态" prop="status" v-if="form.id">
              <el-select v-model="form.status" placeholder="选择状态">
                <el-option label="待审核" :value="0"></el-option>
                <el-option label="营业中" :value="1"></el-option>
                <el-option label="已关闭" :value="2"></el-option>
                <el-option label="已禁用" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择地址">
              <addr-select
                @getform="changeMapAddr"
                :addr="{
                  province: form.province,
                  city: form.city,
                  district: form.district,
                }"
              ></addr-select>
            </el-form-item>
            <el-form-item label="省市区" required prop="city">
              <city-select @change="changeCity" :temp="cityList"></city-select>
            </el-form-item>
            <el-form-item label="详细地址" required prop="address">
              <el-input
                v-model="form.address"
                placeholder="请输入地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="经度">
              <el-input
                v-model="form.longitude"
                placeholder="经度longitude"
              ></el-input>
            </el-form-item>
            <el-form-item label="纬度">
              <el-input
                v-model="form.latitude"
                placeholder="纬度latitude"
              ></el-input>
            </el-form-item>
            <el-form-item label="店铺说明">
              <el-input
                type="textarea"
                :rows="4"
                v-model="form.shop_desc"
                placeholder="店铺说明"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          v-if="form.id"
          type="primary"
          @click="updateForm"
          :loading="loading"
          >更 新</el-button
        >
        <el-button v-else type="primary" :loading="loading" @click="addForm"
          >新 增</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import citySelect from "@/components/select/citySelect.vue";
import { ObjectChangedValue } from "@/js/utils.js";
import cooperatorSelect from "@/components/select/cooperatorSelect.vue";

export default {
  components: {
    citySelect,
    cooperatorSelect,
  },
  props: {
    coopId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      rules: {
        shop_name: [
          { required: true, message: "请填写店铺名称", trigger: "blur" },
        ],
        coop_id: [
          { required: true, message: "请选择所属合作商", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择省市区", trigger: "change" }],
        address: [
          { required: true, message: "请填写详细地址", trigger: "blur" },
        ],
      },
      form: {},
      temp: {},
      cityList: [],
      dialogVisible: false,
      loading: false,
    };
  },

  methods: {
    changeCoop(item) {
      this.$set(this.form, "coop_id", item.id);
    },
    addForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$axios({
            url: "/user/shop/insert",
            method: "post",
            data: this.form,
          })
            .then((res) => {
              this.$notify({
                message: "新增成功",
                duration: 2000,
                type: "success",
              });
              this.dialogVisible = false;
              this.loading = false;
              this.$emit("success", 1);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    updateForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = ObjectChangedValue(this.temp, this.form);
          if (Object.keys(data).length == 0) {
            this.$message("没有修改数据，无需更新");
            return;
          }
          this.loading = true;
          this.$axios({
            url: "/user/shop/update",
            method: "post",
            data: {
              id: this.form.id,
              ...data,
            },
          })
            .then((res) => {
              this.$notify({
                message: "更新成功",
                duration: 2000,
                type: "success",
              });
              this.dialogVisible = false;
              this.loading = false;
              this.$emit("success", 1);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    open(info) {
      if (info && info.id) {
        this.form = {};
        this.temp = {};
        this.cityList = [];
        this.$axios({
          url: "/user/shop/findById",
          params: {
            id: info.id,
          },
        }).then((res) => {
          let data = res.data.data;
          this.temp = Object.assign({}, data);
          this.form = data;
          this.cityList = [data.province, data.city, data.district];
        });
      } else {
        this.form = {
          coop_id: this.coopId || "",
          status: 0,
          sort: 0,
        };
        this.temp = {};
        this.cityList = [];
      }
      this.dialogVisible = true;
    },
    //选择地址
    changeMapAddr(addr) {
      this.$set(this.form, "province", addr.province);
      this.$set(this.form, "city", addr.city);
      this.$set(this.form, "district", addr.district);
      this.$set(this.form, "latitude", addr.addrPoint.lat);
      this.$set(this.form, "longitude", addr.addrPoint.lng);
      this.$set(this.form, "address", addr.address);
      this.cityList = [addr.province, addr.city, addr.district];
    },
    changeCity(v) {
      this.$set(this.form, "province", v[0]);
      this.$set(this.form, "city", v[1]);
      this.$set(this.form, "district", v[2]);
      this.cityList = v;
    },
  },
};
</script>

<style lang="less" scoped>
</style>
